import { Pipe, PipeTransform } from '@angular/core';
import { CallRecording } from '../../../generated/graphql';


@Pipe({ name: 'sentiment' })
export class SentimentPipe implements PipeTransform {
  transform(value: number): String {
    if (value == 0) return "Positive";
    if (value == 1) return "Neutral";
    if (value == 2) return "Negative";
    if (value == 3) return "Mixed";
    return "";
  }
}



